import { MutationTree } from 'vuex';
import { ETemplateUsageMutation } from '@/content-library/template-usage/store/template-usage.constants';
import { ITemplateUsageState } from '@/content-library/template-usage/store/template-usage.types';
import { IDocument } from '@/types/Document';

export const mutations: MutationTree<ITemplateUsageState> = {
  [ETemplateUsageMutation.SetLoaded](state: ITemplateUsageState, loaded: boolean) {
    state.loaded = loaded;
  },
  [ETemplateUsageMutation.SetLoading](state: ITemplateUsageState, loading: boolean) {
    state.loading = loading;
  },
  [ETemplateUsageMutation.SetState](state: ITemplateUsageState, newState: ITemplateUsageState) {
    state.loaded = newState.loaded;
    state.loading = newState.loading;
    state.templates = newState.templates;
  },
  [ETemplateUsageMutation.SetTemplates](state: ITemplateUsageState, templates: IDocument[]) {
    state.templates = templates;
  },
};
